<template>
  <!-- 培训机构列表 -->
  <div>
    <top :keyword="''" :tab="'school'" v-on:change="search"></top>
    <div class="school-top">
      <div class="inschool">
        <div class="selectcity" style="position:absolute;left:0;">
          <span>选择地区：</span>
          <el-cascader style="width:167px;margin-right: 25px;" v-model="provId" expand-trigger="hover" :options="options"
            :props="props" ref="orgSelect" :show-all-levels="false" clearable></el-cascader>
        </div>
        <div class="selectkind" style="position:absolute;left:0;top:50px;">
          <span>工种：</span>
          <el-select v-model="occupationId" style="width:167px;margin-right: 25px;" placeholder="请选择工种" clearable>
            <el-option v-for="option in arr" :key="option.id" :value="option.id" :label="option.name"></el-option>
          </el-select>
          <el-select v-model="gradeId" style="width:167px;margin-right: 25px;" placeholder="请选择等级" clearable>
            <el-option v-for="grade in grades" :key="grade.id" :value="grade.id" :label="grade.name"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="module media-list media-list-type-13"
      style="width: 1184px;height:1000px;text-align: left;margin: 50px auto 0;">
      <div class="pure-u-1-5" v-for="(s, index) in schools" :key="index">
        <div class="column-inner">
          <div class="media media-bg-white media-normal media-card common__box-shadow">
            <a class="object">
              <pic class="img-responsive" :src="s.logoUrl" alt="加载失败" width="143px" height="143px" />
            </a>
            <div class="caption">
              <div class="headline">
                <router-link :to="'/school/' + s.id"
                  style="width:100%;height:100%;float:left;white-space: normal;font-size: 17px;word-wrap: break-word;word-break: break-all;">{{
                    s.name }}</router-link>
                <br />
                <p class="brief">{{ s.briefIntroduction }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import top from './top'
import bottom from './bottom'

export default {
  name: 'school',
  data () {
    return {
      schools: [],
      options: [],
      props: {
        value: 'id',
        label: 'name',
        emitPath: false,
        checkStrictly: true
      },
      arr: [], //工种list
      grades: [], //等级list
      occupationId: '',
      gradeId: '',
      provId: '',
      name: ''
    }
  },
  computed: {},
  created () {
    this.getOccupation()
    this.getOccuGrade()
    this.getSchool()
    this.option()
  },
  methods: {
    // 工种列表
    getOccupation () {
      let platformId = localStorage.getItem('datas')
      this.$axios
        .get(this.$managePath + '/offline/api/occupation/list', {
          params: { platformId }
        })
        .then(res => {
          this.arr = res.data.data
        })
    },
    // 工种等级列表
    getOccuGrade () {
      let platformId = localStorage.getItem('datas')
      this.$axios
        .get(this.$managePath + '/offline/api/occupationGrade/list', {
          params: { platformId }
        })
        .then(res => {
          this.grades = res.data.data
        })
    },
    option () {
      let platformId = localStorage.getItem('datas')
      this.$axios
        .get(this.$managePath + '/offline/api/org/getArea', {
          params: { platformId }
        })
        .then(res => {
          let list = res.data.data
          function getOption () {
            let pidStr = 'parentId'
            let idStr = 'id'
            let childrenStr = 'children'
            let listObj = {}
            let treeList = []
            for (let i = 0; i < list.length; i++) {
              listObj[list[i][idStr]] = list[i]
            }
            for (let j = 0; j < list.length; j++) {
              let haveParent = listObj[list[j][pidStr]]
              if (haveParent) {
                !haveParent[childrenStr] &&
                  (haveParent[childrenStr] = [])
                haveParent[childrenStr].push(list[j])
              } else {
                treeList.push(list[j])
              }
            }
            return treeList
          }

          var a = getOption()
          this.options = a
        })
        .catch(res => {
          console.log('err')
        })
    },
    search (topKeyword) {
      this.name = topKeyword
    },
    // 线下机构列表
    getSchool () {
      let data = {
        platformId: localStorage.getItem('datas'),
        name: this.name,
        occupationId: this.occupationId,
        gradeId: this.gradeId,
        orgId: this.provId
      }
      var qs = require('qs')
      this.$axios
        .get(
          this.$managePath + '/yzsApi/offline/?' + qs.stringify(data)
        )
        .then(res => {
          this.schools = res.data.data.list
        })
    }
  },
  beforeMount () { },
  watch: {
    occupationId: function () {
      this.getSchool()
    },
    gradeId: function () {
      this.getSchool()
    },
    provId: function () {
      if (this.$refs.orgSelect) {
        this.$refs.orgSelect.dropDownVisible = false //监听值发生变化就关闭它
      }
      this.getSchool()
    }
  },
  components: {
    bottom: bottom,
    top: top
  }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
@import '../assets/css/cms.css';

.school-top {
  width: 100%;
  height: 100px;
  /* background: #ccc; */
  margin-top: 20px;
}

.inschool {
  width: 1184px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  /* background: #ccc;  */
  /* border: 1px solid #eee; */
}

.headline {
  height: 60px;
}

.brief {
  width: 100%;
  font-size: 14px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 10px;
}

.img-responsive:after {
  content: "";
  display: inline-block;
  z-index: 2;
  width: 143px;
  height: 143px;
  margin-top: -21px;
  background-image: url("../assets/images/peixun.png");
  background-size: cover;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/school.vue